import React from "react";
import {Col, Form, FormGroup, Collapse, Label} from "reactstrap";
import NombreInput from "./NombreInput";
import PricesTable from "./PricesTable";
import { withTranslation} from 'react-i18next';
import DimensionInput from "./DimensionInput";
import {getShopInfosInStorage} from "tunnel-commande/src/components/cart/ShopInfos";


interface PriceListState {
  marquageId: number;
  quantite: number;
  dimensions: any;
  dimensionsValides: boolean;
  price: number;
  file: any;
  isOpen: boolean;
  simulatePrice: boolean;
}

class PriceList extends React.Component<any, PriceListState> {

  private readonly dimensions: any = null;
  private cancelRequestPrice: any;
  constructor(props: any) {
    super(props);
    this.dimensions = getShopInfosInStorage() ?  getShopInfosInStorage().dimensionsVisuel : {};
    this.cancelRequestPrice = null;
    this.handleOnFormSubmit = this.handleOnFormSubmit.bind(this);
    this.handleOnFormChange = this.handleOnFormChange.bind(this);
    this.setDimensions = this.setDimensions.bind(this);

    this.state = {
      marquageId: 0,
      quantite: 0,
      dimensions: {l: 0, h: 0},
      price: 0,
      dimensionsValides: false,
      file: null,
      isOpen: true,
      simulatePrice: true
    };
  }

  private handleOnFormSubmit(e: any) {
    e.preventDefault();
  }

  private handleOnFormChange(e: any) {
    const target: any = e.target;
    const name: any = target.name;
    const value: any = target.value;
    this.setState({
      ...this.state, [name]: value
    }, this.dimensionsValides);
  }

  private dimensionsValides() {

    const isValidL = (this.state.dimensions.l >= this.dimensions.centimetreMinLargeur && this.state.dimensions.l <= this.dimensions.centimetreMaxLargeur);
    const isValidH = (this.state.dimensions.h >= this.dimensions.centimetreMinHauteur && this.state.dimensions.h <= this.dimensions.centimetreMaxHauteur);
    const surfaceMax = this.dimensions.centimetreMaxLargeur * this.dimensions.centimetreMaxHauteur;
    const surfaceMin = this.dimensions.centimetreMinLargeur * this.dimensions.centimetreMinHauteur;
    const currentSurface = this.state.dimensions.l * this.state.dimensions.h;

    const valide = isValidL && isValidH && currentSurface >= surfaceMin &&  currentSurface <= surfaceMax ;
    this.setState({
      ...this.state, dimensionsValides: valide
    });
  }

  private setDimensions(largeur: number, hauteur: number) {
    this.setState({
      dimensions: {l: largeur, h: hauteur},
    });
    if (this.state.file) {
      this.setState({
      }, this.dimensionsValides);
    }
  }

  render() {
    // @ts-ignore
    return (
      <>
        <Col className={'my-4 p-0'}  xs={'12'}>
          <div className={'border-bottom text-uppercase  font20 mb-2 py-2 d-flex align-items-center border-dark'}>
            <span className={'bold text-underline'}>{this.props.t('price_list')}</span> <span className={'text-lowercase no-bold ml-2 italic font14'}>({this.props.t('unit_prices_without_taxes')})</span>
          </div>
          <Collapse isOpen={this.state.isOpen}>
          <Form className={'form-cmd-dt'}>
            <FormGroup className={'mt-4 mt-md-2'}>
               <PricesTable simulatePrice={this.state.simulatePrice} data={this.props.priceTable} dimensions={this.state.dimensions} quantite={this.state.quantite}/>
            </FormGroup>
            {this.state.simulatePrice &&
            <div className={'d-flex align-items-center justify-content-center flex-column'}>
              <span className={'font20 text-uppercase pb-1 pt-3 mt-3 mr-3 d-none'}>{this.props.t('view_price')} :</span>
              <div className={'d-flex  py-1 py-md-4 align-items-center ml-0 ml-md-4'}>
                <DimensionInput onlyGrid={this.props.onlyGrid} onChange={(dimensions: any) => {
                  this.handleOnFormChange({target: {name: "dimensions", value: dimensions}})
                }} dimension={this.state.dimensions} disabled={false}/>
                <div className={"ml-0 ml-md-4 pl-4"}>
                  <Label className={'grey white-space-nowrap'}>{this.props.t('quantity')} :</Label>
                  <NombreInput onlyGrid={this.props.onlyGrid} onChange={(quantite: any) => {
                    this.handleOnFormChange({target: {name: "quantite", value: quantite.target.value}})
                  }} quantite={this.state.quantite} disabled={!this.dimensionsValides}/>
                </div>
                {!this.props.onlyGrid &&
                <div>
                  {this.state.price}€
                </div>
                }
              </div>
            </div>
            }
          </Form>
          </Collapse>
        </Col>
      </>
    );
  }
}
export default withTranslation('common')(PriceList);
